export default {
  title: 'All courses',
  searchPH: 'Search by course name',
  noCourses: 'No courses found',
  nameTaken: 'This name in the category already exists.',
  addNewContent: 'Add new content',
  delete: 'Delete',
  cancel: 'Cancel',
  delContentTitle: 'Delete content',
  delContentWarn: 'Are you sure you want to remove this content ?',
  delCourseTitle: 'Delete course',
  delCourseWarn: 'Are you sure you want to remove this whole course ?',

  renameCourseTitle: 'Rename course',
  renameCourseOK: 'Rename',
  renameCourseLabel: 'Course name*',
  renameCoursePlaceholder: 'The new course name',

  copyCourseTitle: 'Duplicate course',
  copyCourseOK: 'Duplicate',
  copyCourseLabel: 'Course name*',
  copyCoursePlaceholder: 'The new course name',

  changeContentTypeTitle: 'Change content type',
  changeContentTypeOK: 'Change type',
  changeContentTypeNew: 'New type*',

  saveSuccess: 'Successfully saved!',
  contentEmpty: 'Empty content',
  backToOverview: 'Go to overview',
  goToContent: 'Go to content',
  content: 'Content',
  editContentButton: 'Edit content',
  editContent: (step) => `This will allow you to edit the content No. <b>${step}</b> shown above.`,
  editContentType: 'Change content type',
  editContentTypeText: 'This allows you to permanently change the type of content.<br><b>Warning:</b> The current entries will be lost.',
  learningModules: 'Learning modules',
  learningChecks: 'Learning checks',
  newContentText: (id) => `You can use it to create new content.<br>It will be number <b>${id}</b>.`,
  editCourseNav: 'Edit course guidance',
  incomplete: 'Incomplete',
  editCourseNavText: (count) => `You can use it to edit the course guidance.<br>The course has a total of <b>${count}</b> contents.`,

  renameCourseButton: 'Rename course',
  renameCourseAction: 'The course will be renamed',
  copyCourseButton: 'Duplicate course',
  copyCourseAction: 'The course will be duplicated with a new name',
  removeContentButton: 'Remove content',
  removeContentAction: 'The current content will be removed.',
  removeCourseButton: 'Remove course',
  removeCourseAction: 'The <b>entire course</b> will be removed.',
}
